import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import { Checkbox, Typography } from '@mui/material';
import { addDays, addHours, format, parse, startOfWeek } from 'date-fns';
import Button from 'components/atoms/Button';
import { EButtonVariants } from 'constants/Buttons';
import { EIconTypes } from 'constants/Icons';
import {
  StyledDayCell,
  StyledDayHead,
  StyledDayWrapper,
  StyledNavigator,
  StyledSidebar,
  StyledSidebarDetails,
} from './styles';

const range = Array.from({ length: 11 }, (_, i) => String(i + 8).padStart(2, '0'));

const AppointmentStep = () => {
  const [monday, setMonday] = useState<Date>();
  const [week, setWeek] = useState<Date[]>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [checked, setChecked] = useState<string>('');

  useEffect(() => {
    setMonday(startOfWeek(new Date(), { weekStartsOn: 1 }));
  }, []);

  const handleChangeWeek = (number: number) => {
    setMonday((prev) => prev && addDays(prev, number));
  };

  useEffect(() => {
    if (monday) {
      const weekRange = Array.from({ length: 5 }, (_, i) => addDays(monday, i));
      // const weekFormattedT = week.map((date) => format(date, 'yyyy-MM-dd'));
      setWeek(weekRange);
    }
  }, [monday]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setChecked(event.target.value);
    } else {
      setChecked('');
    }
  };

  const getFormattedDate = () => {
    const formatString = 'yyyy-MM-dd:HH';
    const date = parse(checked, formatString, new Date());
    const endDate = addHours(date, 1);
    return `${format(date, "EEEE, d MMMM HH'.'mm")} - ${format(endDate, "HH'.'mm")}`;
  };

  return (
    <Grid container>
      <Grid item container xs={9}>
        <StyledNavigator item container xs={12}>
          <Grid item xs={4}>
            <Button
              icon={EIconTypes.arrowLeft}
              label="Previous Week"
              variant={EButtonVariants.text}
              onClick={() => handleChangeWeek(-7)}
            />
          </Grid>

          <Grid item xs={4} sx={{ textAlign: 'center' }}>
            {monday && (
              <>
                {format(monday, 'd MMMM')} - {format(addDays(monday, 4), 'd MMMM yyyy')}
              </>
            )}
          </Grid>

          <Grid item xs={4} sx={{ textAlign: 'right' }}>
            <Button
              icon={EIconTypes.right}
              endIcon={true}
              label="Next week"
              variant={EButtonVariants.text}
              onClick={() => handleChangeWeek(7)}
            />
          </Grid>
        </StyledNavigator>

        <Grid item container xs={12} direction="row" gap={1}>
          {week?.map((date) => (
            <StyledDayWrapper>
              <StyledDayHead>
                <div>{format(date, 'EEE').toUpperCase()}</div>
                <div>{format(date, 'yyyy-MM-dd')}</div>
              </StyledDayHead>
              {range.map((item) => (
                <StyledDayCell selected={checked === `${format(date, 'yyyy-MM-dd')}:${item}`}>
                  <div>{item}:00</div>
                  <div>
                    <Checkbox
                      value={`${format(date, 'yyyy-MM-dd')}:${item}`}
                      checked={checked === `${format(date, 'yyyy-MM-dd')}:${item}`}
                      onChange={handleChange}
                    />
                  </div>
                </StyledDayCell>
              ))}
            </StyledDayWrapper>
          ))}
        </Grid>
      </Grid>

      <Grid item xs={3}>
        <StyledSidebar selected={!!checked}>
          <Typography variant="h5">Appointment Details</Typography>

          <StyledSidebarDetails>
            <div>
              <Typography variant="subtitle2">Date and Time</Typography>
              <Typography variant="subtitle2">
                {checked ? getFormattedDate() : 'N/A'}
              </Typography>
            </div>
            <div>
              <Typography variant="subtitle2">The Officer</Typography>
              <Typography variant="subtitle2">
                {checked ? 'Marlene Ullrich' : 'N/A'}
              </Typography>
            </div>
            <div>
              <Typography variant="subtitle2">Phone Number</Typography>
              <Typography variant="subtitle2">{checked ? '636-279-6252' : 'N/A'}</Typography>
            </div>
          </StyledSidebarDetails>

          <Grid container xs={12} columnSpacing={1}>
            <Grid item xs={6}>
              <Button
                label="Cancel"
                fullWidth
                variant={EButtonVariants.outlined}
                disabled={!checked}
                onClick={() => setChecked('')}
              />
            </Grid>
            <Grid item xs={6}>
              <Button
                label="Save"
                fullWidth
                variant={EButtonVariants.contained}
                disabled={!checked}
              />
            </Grid>
          </Grid>
        </StyledSidebar>
      </Grid>
    </Grid>
  );
};

export default AppointmentStep;
